export default {
    title:'School',
    schoolName:'School Name',
    address:'School Address',
    save:'Save',
    cancel:'Cancel',
    addSchool:'Add School',
    dob:'DOB',
    IEMISNumber:'IEMIS Number',
}